import * as React             from 'react';
import {cs}                   from "@Common/react/chain-services";

import {ReactGAGuestEvent }   from "@Common/libs/ga/xd-react-ga";
import {consumeContext}       from "@Common/react/context";
import {BubbleNoti}           from '@Common/ui-components/bubble-noti/bubble-noti';
import {GoogleOAuthProvider,
        useGoogleOneTapLogin} from "@react-oauth/google";

export const LoadGoogleAutoLogin = () => cs(
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("userLevels"),
    consumeContext("systemConstants"),
    ["bubbleNoti", (_, next) => BubbleNoti({next})],
    ({apis, company, userLevels, systemConstants, bubbleNoti}) => (<>
        {userLevels?.isGuest && !disableGoogleAutoLogin() && company?.prefs.enableGoogleIdLogin &&
        <GoogleOAuthProvider
            clientId={systemConstants.value?.GOOGLE_CLIENT_ID}
        >
            <AutoLogin apis={apis} bubbleNoti={bubbleNoti}/>
        </GoogleOAuthProvider>}
    </>)
)

const AutoLogin = ({apis, bubbleNoti}) => {
    document.cookie = "disable_google_auto_login=1; path=/",
    useGoogleOneTapLogin({
        onSuccess: (credentialResponse) => {
            handleLogin({credentialResponse, apis, bubbleNoti})
        },
        onError: () => {
            console.log('failed')
        },
        auto_select: true
    })
    return null
}

let disableOneTapPopup = null;
const disableGoogleAutoLogin = () => {
    if( disableOneTapPopup === null)
    {
        disableOneTapPopup = false
        document.cookie.split(';').forEach(pair => {
            if(pair.trim().startsWith('disable_google_auto_login'))
            disableOneTapPopup = pair.split('=')[1] === "1";
        })
    }
    return disableOneTapPopup
}

const handleLogin = async ({credentialResponse, apis, bubbleNoti}) => {
    try {
        var token = credentialResponse.credential
        bubbleNoti.show({
            message: "Signing in... Please wait",
            color: "green",
            duration: 3000
        })
        let data = await apis.next.authenticate.googleLogin({
            token
        })
        if( data.statusCode === "success" ) {
            ReactGAGuestEvent({
                eventName: "login",
                method: "Google",
                reason: data.message,
                statusCode: data.statusCode
            })
            location.reload()
        } else if( data?.data?.idUser ) {
            let data = await apis.next.authenticate.login({
                existingAccount: true,
            })
            if( data.statusCode === "success" ) {
                ReactGAGuestEvent({
                    eventName: "login",
                    method: "Google",
                    reason: data.message,
                    statusCode: data.statusCode
                });
                window.location.replace("/app");
            } else {
                ReactGAGuestEvent({
                    eventName: "login_failed",
                    method: "Google",
                    reason: data.message,
                    statusCode: data.statusCode
                }),
                bubbleNoti.show({
                    message: "Login Failed",
                    color: "red",
                    duration: 4000
                })
            }
        } else {
            bubbleNoti.show({
                message: "Login Failed",
                color: "red",
                duration: 4000
            }),
            ReactGAGuestEvent({
                eventName: "login_failed",
                method: "Google",
                reason: data.message,
                statusCode: data.statusCode
            })
        }
    } catch (error) {
        console.error(error);
    }
}
